// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fontSize15[data-v-69ccd726] {
  font-size: 15px;
}
.display-inline-block[data-v-69ccd726] {
  display: inline-block;
}
.display-inline[data-v-69ccd726] {
  display: inline !important;
}
.fee-block[data-v-69ccd726] {
  font-size: 0.85em;
}
.fees-circle[data-v-69ccd726] {
  border-radius: 50%;
  width: 45px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border: 1px solid cadetblue;
}
.fee-row[data-v-69ccd726] {
  font-size: 12px;
}
/*.fee-name {*/
/*    !*line-height: 45px;*!*/
/*}*/
.charge-wrapper[data-v-69ccd726] {
  text-align: left;
}
/*span:not(.markedBottom) {*/
/*    display: inline-block;*/
/*    vertical-align: middle;*/
/*    line-height: normal;*/
/*}*/
`, "",{"version":3,"sources":["webpack://./src/js/pages/application/equipment_pricing/pricing.vue","webpack://./pricing.vue"],"names":[],"mappings":"AACI;EACI,eAAA;ACAR;ADGI;EACI,qBAAA;ACDR;ADII;EACI,0BAAA;ACFR;ADMI;EACI,iBAAA;ACJR;ADOI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;ACLR;ADQI;EACI,eAAA;ACNR;AACA,cAAc;AACd,6BAA6B;AAC7B,IAAI;ADSA;EACI,gBAAA;ACPR;AACA,4BAA4B;AAC5B,6BAA6B;AAC7B,8BAA8B;AAC9B,2BAA2B;AAC3B,IAAI","sourcesContent":["\n    .fontSize15 {\n        font-size: 15px;\n    }\n\n    .display-inline-block {\n        display: inline-block;\n    }\n\n    .display-inline {\n        display: inline !important;\n    }\n\n\n    .fee-block {\n        font-size: 0.85em;\n    }\n\n    .fees-circle {\n        border-radius: 50%;\n        width: 45px;\n        height: 45px;\n        line-height: 45px;\n        text-align: center;\n        border: 1px solid cadetblue;\n    }\n\n    .fee-row {\n        font-size: 12px;\n    }\n\n    /*.fee-name {*/\n    /*    !*line-height: 45px;*!*/\n    /*}*/\n    .charge-wrapper {\n        text-align: left;\n    }\n    /*span:not(.markedBottom) {*/\n    /*    display: inline-block;*/\n    /*    vertical-align: middle;*/\n    /*    line-height: normal;*/\n    /*}*/\n",".fontSize15 {\n  font-size: 15px;\n}\n.display-inline-block {\n  display: inline-block;\n}\n.display-inline {\n  display: inline !important;\n}\n.fee-block {\n  font-size: 0.85em;\n}\n.fees-circle {\n  border-radius: 50%;\n  width: 45px;\n  height: 45px;\n  line-height: 45px;\n  text-align: center;\n  border: 1px solid cadetblue;\n}\n.fee-row {\n  font-size: 12px;\n}\n/*.fee-name {*/\n/*    !*line-height: 45px;*!*/\n/*}*/\n.charge-wrapper {\n  text-align: left;\n}\n/*span:not(.markedBottom) {*/\n/*    display: inline-block;*/\n/*    vertical-align: middle;*/\n/*    line-height: normal;*/\n/*}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
